import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { useFetch } from '@shell/components/Resource/Detail/FetchLoader/composables';

/**
 * Shows how many times the pods of a workload have restarted, adding up the RESTARTS column of `kubectl get pods`.
 *
 * Pods the store already has, e.g. when a popover shows a ReplicaSet on the page of its Deployment, are used as they
 * are and kept up to date over the websocket. Otherwise they're fetched when this is shown, e.g. on the page of a pod,
 * which only has that pod. Avoid it in lists, where every row could fetch its pods
 */
export interface Props {
  /**
   * The workload
   */
  row: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkloadPodRestarts',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);

const storePods = computed(() => props.row.podsInStore);

const fetch = useFetch(async() => {
  if (storePods.value) {
    return undefined;
  }

  return (await (props.row.fetchGlancePods ? props.row.fetchGlancePods() : props.row.matchingPods())) || [];
});

const pods = computed(() => storePods.value || fetch.value.data);

const restarts = computed(() => pods.value?.reduce((total: number, pod: any) => total + (pod.totalRestartCount || 0), 0));

return (_ctx: any,_cache: any) => {
  return (!pods.value && _unref(fetch).loading)
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: "icon icon-spinner icon-spin",
        role: "status",
        "aria-label": _unref(i18n).t('component.resource.detail.glance.ariaLabel.loading')
      }, null, 8, _hoisted_1))
    : (restarts.value === undefined)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "—"))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(restarts.value), 1))
}
}

})